import React, {useLayoutEffect} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from "react-i18next";
import EditLabelButton from "../edit-label-button";
import DeleteLabelButton from "../delete-label-button";
import {dropDownPosition} from "../../../../../../../../utils";
import DirectoryParamButton from '../directory-param-button';

function LabelMoreOptionDropdown ({id, name, type, status, activeDirectory, permission, directorySyncStatus}) {

    const  {t} = useTranslation();

    const profile = useSelector( state => state.profileReducer.getProfile);

    useLayoutEffect(() => {
        dropDownPosition(document.querySelector(`.label[id="${id}"]`), document.querySelector(`.label[id="${id}"] .more-options`), document.querySelector(`.label[id="${id}"] .more-options-dropdown`));
    }, [id]);

    return (
        <ul className="more-options-dropdown" >
            {
                (type === "contact" || type === "childContact" || type === "childContactLv2") && status !== 'SHARED_WITH_ME' && <li>
	                <EditLabelButton
		                title={t("renameText")}
		                labelId={id}
		                labelName={name}
	                />
                </li>
            }
            {
	            (type === "contact" || type === "childContact" || type === "childContactLv2") && status !== 'SHARED_WITH_ME' && <li>
		            <DeleteLabelButton
			            title={t("deleteLabel")}
			            labelId={id}
			            labelName={name}
		            />
	            </li>
            }
	        {
		        type === "directory"
		        && activeDirectory
		        && profile.isAdmin === true
		        && <li>
			        <DirectoryParamButton
				        title={"Parameters"}
			        />
                </li>
	        }
        </ul>
    )
}

export default LabelMoreOptionDropdown;
